import { createContext, useContext } from "react";

import type { FindDefinitions } from "../types/index.ts";

type LibraryContext = {
  findDefinitions: FindDefinitions;
};

export const LibraryContext = createContext<LibraryContext | undefined>(undefined);

LibraryContext.displayName = "LibraryContext";

export const useLibraryContext = () => {
  const context = useContext(LibraryContext);
  if (!context) {
    throw new Error(`Expected ${LibraryContext.displayName} in ancestor tree.`);
  }

  return context;
};
